import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services';
import { IAuthenticator, AuthType } from '@ext-interfaces/authenticator.model';
import { environment } from 'projects/extensions/src/environments/environment';
import { catchError } from 'rxjs/operators';
import { LOGIN_ROUTE } from '../../interfaces/app-data.model';
import { TokenService } from './token.service';

declare var $: any;
@Injectable({
    providedIn: 'root'
})
export class GoogleAuthenticatorService implements IAuthenticator {
    public isAuthenticating = false;

    constructor(private apiService: ApiService, private tokenService: TokenService) {}

    authenicateGoogleUser(): void {
        this.getAuthParams('noemail').then(
            (params) => {
                this.apiService
                    .post(LOGIN_ROUTE, params)
                    .pipe(
                        catchError((err) => {
                            this.showToast('error', `An error occurred while authenticating through Google 1: ${err}`);
                            return err;
                        })
                    )
                    .subscribe((response) => {
                        this.redirectForAuth(response.url);
                    });
            },
            (err) => {
                this.showToast('error', `An error occurred while authenticating through Google 2: ${err}`);
            }
        );
    }

    private getAuthParams(permissions?: 'noemail' | string) {
        const token = this.tokenService.getToken();

        return new Promise((resolve) => {
            // TODO: type data
            window.addEventListener('message', function (data) {
                if (data.data && data.data.type === 'gmail') {
                    return;
                }
                resolve({
                    permissions: permissions,
                    user: {
                        name: data.data,
                        messaging: [
                            {
                                id: data.data,
                                meta: {
                                    token: token
                                },
                                type: 'chrome'
                            }
                        ]
                        // ...(environment.localDebugMode ? { redirect_uri: LOCAL_DEV_TESTING_API_URI } : {})
                    },
                    loginType: 'google'
                });
            });

            window.parent.postMessage({ event_id: 'profile' }, '*');
        });
    }

    private redirectForAuth(url: string) {
        // During local development, have the chrome extension redirect for auth
        if (environment.localDevData) {
            window.open(url);
        } else {
            // In production, the chrome extension will open a new tab from the extension popup for auth
            window.parent.postMessage(
                {
                    event_id: 'authenticate',
                    data: {
                        url
                    }
                },
                '*'
            );
        }
    }

    authenicateMicrosoftUser(authType: AuthType, data: { email: string; password?: string }): void {
        throw new Error('Method not implemented, check if ENV variables are properly set.');
    }

    private showToast(type: 'error' | 'success', message: string) {
        $('body').toast({
            class: type,
            message
        });
    }
}
